import routerOptions0 from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}